import { env } from "../../../env";
const axios = require("axios").default;

const URL_ORI = `${env.REACT_APP_API_URL}`;

export const getParameter = (payload) => {
  return axios
    .get(`${URL_ORI}/api/bispar/param/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getParameterGroup = (payload) => {
  return axios
    .get(`${URL_ORI}/api/bispar/group/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getParameterGroupCode = (id) => {
  return axios
    .get(`${URL_ORI}/api/bispar/paramGroup/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createParameterGroup = (payload) => {
  return axios.post(`${URL_ORI}/api/bispar/group`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const createParameter = (payload) => {
  return axios.post(`${URL_ORI}/api/bispar/param`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const getIdParameterGroup = (id) => {
  return axios
    .get(`${URL_ORI}/api/bispar/group/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const getIdParameter = (id) => {
  return axios
    .get(`${URL_ORI}/api/bispar/param/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateParameter = (id, payload) => {
  return axios
    .put(`${URL_ORI}/api/bispar/group/${id}`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateParameterGroup = (id, payload) => {
  return axios
    .put(`${URL_ORI}/api/bispar/param/${id}`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

// export const deleteById = (payload) => {
//   return axios.delete(URL, payload).catch((error) => {
//     if (error.response) {
//       return error.response;
//     } else if (error.request) {
//       console.log(error.request);
//     } else {
//       console.log(error.message);
//     }
//   });
// };
